import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {HoomvipStorage} from '../hoomvip-storage/hoomvip-storage.service';

@Injectable({providedIn: 'root'})
export class RouterService {
  constructor(
    private router: Router,
    private storage: HoomvipStorage,
  ) {
  }

  public goToHome() {
    this.navigate(['/home']);
  }

  public isHomePage(): boolean {
    return this.router.url === '/home' || this.router.url === '/';
  }

  public navigate(commands: any[]): Promise<boolean> {
    return this.router.navigate(commands, {
      queryParamsHandling: 'preserve',
    });
  }

  public navigateByUrl(url: string, extras: {replaceUrl?: boolean} = {}): Promise<boolean> {
    return this.router.navigateByUrl(this.withBrandingParam(url), extras);
  }

  public withBrandingParam(url: string): string {
    const brandingCode = this.storage.getBrandingCode();

    if (!brandingCode || this.isExternalUrl(url)) {
      return url;
    }

    const parsedUrl = new URL(url, window.location.origin);

    if (!parsedUrl.searchParams.has(environment.brandingCodeQueryParam)) {
      parsedUrl.searchParams.set(environment.brandingCodeQueryParam, brandingCode);
    }

    if (parsedUrl.origin === window.location.origin) {
      return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    }

    return parsedUrl.toString();
  }

  private isExternalUrl(url: string): boolean {
    return /^(https?:|mailto:|tel:|sms:|geo:)/i.test(url);
  }
}
